var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-chat-page"},[_c('BasePageTitle',{attrs:{"title":_vm.tokens.footer.liveChat},scopedSlots:_vm._u([{key:"left-icon",fn:function(){return [_c('span',{staticClass:"circle online"})]},proxy:true}])}),_c('LiveChat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }